import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  readonly translationService = inject(TranslationService);

  readonly brandName = computed(() => this.translationService.t().brandName);
  readonly currentYear = computed(() => new Date().getFullYear());
}
